<template>
    <span v-bind="$attrs"
          :aria-hidden="title ? null : true"
          :aria-label="title"
          class="material-design-icon calculator-icon"
          role="img"
          @click="$emit('click', $event)">
      <svg :fill="fillColor"
           class="material-design-icon__svg"
           :width="size"
           :height="size"
           viewBox="0 0 512.000000 512.000000">

        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        :fill="fillColor" stroke="none">
        <path d="M406 5104 c-134 -32 -279 -146 -344 -270 -66 -126 -62 24 -62 -2274
        0 -2298 -4 -2148 62 -2274 41 -78 146 -183 224 -224 126 -66 -24 -62 2274 -62
        2298 0 2148 -4 2274 62 78 41 183 146 224 224 66 126 62 -24 62 2274 0 2298 4
        2148 -62 2274 -41 78 -146 183 -224 224 -126 66 25 62 -2279 61 -1769 -1
        -2099 -3 -2149 -15z m2044 -1314 l0 -1120 -1120 0 -1120 0 0 968 c0 1027 0
        1035 47 1110 46 74 125 131 210 151 21 5 476 9 1011 10 l972 1 0 -1120z m2213
        1105 c121 -31 200 -111 232 -232 13 -49 15 -199 15 -1025 l0 -968 -1120 0
        -1120 0 0 1120 0 1120 968 0 c824 0 976 -2 1025 -15z m-2213 -3565 l0 -1120
        -992 2 -993 3 -60 28 c-67 32 -106 64 -141 120 -55 84 -54 71 -54 1119 l0 968
        1120 0 1120 0 0 -1120z m2458 128 l-3 -993 -28 -60 c-32 -67 -64 -106 -120
        -141 -84 -55 -71 -54 -1119 -54 l-968 0 0 1120 0 1120 1120 0 1120 0 -2 -992z"/>
        <path d="M1233 4254 c-54 -27 -63 -61 -63 -248 l0 -166 -170 0 c-184 0 -212
        -6 -236 -51 -24 -47 -18 -97 15 -130 l29 -29 181 0 181 0 0 -165 c0 -121 4
        -175 14 -200 15 -35 59 -65 96 -65 37 0 81 30 96 65 10 25 14 79 14 200 l0
        165 181 0 181 0 29 29 c32 32 38 79 17 126 -22 48 -51 55 -238 55 l-170 0 0
        166 c0 188 -9 222 -65 248 -41 20 -52 20 -92 0z"/>
        <path d="M3361 3826 c-58 -32 -69 -119 -22 -167 l29 -29 472 0 472 0 29 29
        c48 49 34 142 -26 169 -39 18 -921 16 -954 -2z"/>
        <path d="M925 1701 c-40 -18 -70 -60 -70 -102 0 -37 8 -46 140 -179 l140 -140
        -140 -140 c-133 -133 -140 -142 -140 -180 0 -57 48 -105 105 -105 38 0 47 7
        180 140 l140 140 140 -140 c133 -133 142 -140 180 -140 57 0 105 48 105 105 0
        38 -7 47 -140 180 l-140 140 140 140 c133 133 140 142 140 180 0 57 -48 105
        -105 105 -38 0 -47 -7 -180 -140 l-140 -140 -137 137 c-141 141 -170 159 -218
        139z"/>
        <path d="M3383 1703 c-59 -11 -94 -109 -57 -162 35 -49 52 -51 514 -51 462 0
        479 2 514 51 9 13 16 39 16 59 0 20 -7 46 -16 59 -35 50 -51 51 -516 50 -238
        -1 -443 -4 -455 -6z"/>
        <path d="M3383 1063 c-59 -11 -94 -109 -57 -162 35 -49 52 -51 514 -51 462 0
        479 2 514 51 9 13 16 39 16 59 0 20 -7 46 -16 59 -35 50 -51 51 -516 50 -238
        -1 -443 -4 -455 -6z"/>
        </g>
        </svg>
    </span>
  </template>
  
  <script>
  export default {
    name: "CalculatorIcon",
    emits: ['click'],
    props: {
      title: {
        type: String,
      },
      fillColor: {
        type: String,
        default: "#000000"
      },
      size: {
        type: String,
        default: "18px"
      }
    }
  }
  </script>